<p-toast key="fileupload"></p-toast>
@if(isAllowToAddProduct) {
<div appAccessProvider [accessCode]="{ menuCode: 'PROTOCOLS', pageCode: 'ALL', subPageCode: 'VIEW' }">
  <app-module-header (onBtnClick)="onAddPatient()" [label]="btnLabel" [zIndex]="0" [disableDefaultStyle]="true"
    [moduleHeaderSecondaryBtnMenuItems]="moduleHeaderSecondaryBtnMenuItems"></app-module-header>
</div>
}
<div class="grid mt-2 mx-3 mr-0">
  <div class="flex justify-content-between col-12 bg-white btn-with-links p-3">
    <label class="font-semibold uppercase category-name category-name" translate>protocol.lbl_patients</label>
  </div>
</div>

<div appAccessProvider [accessCode]="{ menuCode: 'PROTOCOLS', pageCode: 'ALL', subPageCode: 'VIEW' }">

  <div class="mx-3">
    @if (allColumns) {
    <app-mi-table class="w-full"
      [collectionOfColumns]="allColumns"
      [attributeLabels]="filterAttributeLabels"
      [data]="tableData"
      [isLoading]="isLoading" (onPageChange)="onPageChange($event)"
      (itemPerPageChange)="itemPerPageChange($event)"
      [message]="deleteRoleMsg"
      [header]="deleteRoleHeaderMsg"
      (onDelete)="onPatientDelete($event)"
      [filterList]="filterList"
      (onValueChange)="onFilterValueChange($event)"
      [filterFields]="filterFieldsArray"
      [label]="btnLabel"
      (onBtnClick)="onAddPatient()"
      [attributeData]="attributeData"
      [rowItems]="rowItems"
      [bulkSelectionsItems]="bulkSelectionsItems"
      [bulkDeleteLabel]="bulkDeleteLabel"
      (setCurrentRowData)="setCurrentRowData($event)"
      [showBulkUpdateDialog]="showBulkUpdateDialog"
      (onSearchValueChange)="onSearchValueChanges($event)"
      [totalRecords]="totalRecords"
      [visible]="visible"
      (onToggleOverLay)="showBulkUpdateDialog = false"
      (onChangeStatus)="onChangeStatus($event)"
      [isEntity]="isEntity"
      (onSortData)="onSortData($event)"
      entityName="protocol_patient">
    </app-mi-table>
    }
  </div>
</div>
@if (showAddDialog) {
<ng-container>
  <app-add-protocol-patient (closePopup)="hidePopup($event)" [patientId]="patientId" [protocolId]="protocolId"
    [protocolDates]="protocolDates" />
</ng-container>
}

@if (showPauseDialog) {
<p-dialog [header]="pausePatientHeader" [modal]="true" [(visible)]="showPauseDialog" [style]="{ width: '60rem' }"
  (onHide)="closePauseDialog(false)">
  <div class="user-details">
    <div class="alignment-center w-full">
      <form [formGroup]="pauseForm">
        <input type="text" id="hiddenInputPause" #hiddenInputPause
          style="position: absolute; left: -9999px; opacity: 0;" />
        <div class="card border-none px-0 pt-2 pb-0">
          <div class="grid">
            <div class="col-5 md:col-12 lg:col-5 flex flex-column gap-1 input-group">
              <div class="frm-label form-lbl">
                <label for="firstName" class="font-semibold" translate>lbl_from_date</label><span
                  class="text-red-500 ml-1">*</span>
              </div>
              <div class="frm-control">
                <p-calendar class="date-picker booking w-6" [showIcon]="true" autofocus="false"
                  [placeholder]="'lbl_select_date' | translate" (onSelect)="onDateSelect()"
                  appendTo="body" dateFormat="dd/mm/yy" [minDate]="minStartDate" [maxDate]="maxFromDate"
                  formControlName="fromDate" />
              </div>
              @if (pauseForm.controls.fromDate.errors && (pauseForm.controls.fromDate.dirty ||
              pauseForm.controls.fromDate.touched)) {
              <div class="form-errors">
                @if(pauseForm.controls.fromDate.errors?.required && (pauseForm.controls.fromDate.dirty ||
                pauseForm.controls.fromDate.touched)){
                <div [hidden]="!pauseForm.controls.fromDate.errors.required" class="text-red-500" translate>
                  patient.error_from_date_required
                </div>
                }
              </div>
              }
            </div>
            <div class="col-5 md:col-12 lg:col-5 flex flex-column gap-1 input-group">
              <div class="frm-label form-lbl">
                <label for="firstName" class="font-semibold" translate>lbl_to_date</label><span
                  class="text-red-500 ml-1">*</span>
              </div>
              <div class="frm-control">
                <p-calendar class="date-picker booking w-6" [showIcon]="true"
                  [placeholder]="'lbl_select_date' | translate" (onSelect)="onDateSelect()"
                  appendTo="body" dateFormat="dd/mm/yy" [minDate]="minDate" [maxDate]="maxEndDate"
                  formControlName="endDate" />
              </div>
              @if (pauseForm.controls.endDate.errors && (pauseForm.controls.endDate.dirty ||
              pauseForm.controls.endDate.touched) || pauseForm.errors?.endDateInvalid) {
              <div class="form-errors">
                @if(pauseForm.controls.endDate.errors?.required && (pauseForm.controls.endDate.dirty ||
                pauseForm.controls.endDate.touched)){
                <div [hidden]="!pauseForm.controls.endDate.errors.required" class="text-red-500" translate>
                  patient.error_end_date_required
                </div>
                }
              </div>
              }
              @if (pauseForm.errors?.endDateInvalid) {
              <div class="text-red-500" translate>
                patient.error_end_date_greater
              </div>
              }
              @if (pauseForm.errors?.endDateExceedsProtocol) {
              <div class="text-red-500" translate>
                patient.error_end_date_exceeds_protocol
              </div>
              }
            </div>
            <div class="col-2 md:col-4 lg:col-2 flex flex-column gap-1 input-group">
              <div class="frm-label form-lbl">
                <label for="firstName" class="font-semibold" translate>patient.lbl_days</label>
              </div>
              <div class="frm-control">
                <input class="p-component p-element w-full" type="text" [placeholder]="'patient.lbl_days' | translate"
                  pInputText [(ngModel)]="totalDays" disabled="true" [ngModelOptions]="{standalone : true}"
                  tabindex="0" />
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-12 flex flex-column gap-1 input-group">
              <div class="frm-label form-lbl">
                <label class="note-text block w-full mt-2"
                  translate>patient.msg_pause_patient_participation_note</label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <hr class="hr-line">
    <div class="flex save-button justify-content-end pb-3 mr-2">
      <button type="button" pButton [label]="'manage_users.lbl_cancel' | translate" (click)="closePauseDialog(false)"
        class="mr-20 border-none cancel-hover bg-transparent text-color height-44 border-button"
        id="cancelBtnId"></button>

      <button type="button" pButton id="saveBtnId"
        [label]="isUpdatingPause ? ('patient.lbl_update_pause_patient' | translate) : ('patient.lbl_pause_patient' | translate)"
        (click)="onPausePatient()"
        class="height-44 save-add-hover"></button>
    </div>
  </div>
</p-dialog>
}
<input type="file" id="patientFileUploadInput" accept=".xlsx,.xls" (change)="onPatientFileUpload($event, 'report')"
  #fileInput class="hidden" />